export type TopEarningClipRow = {
  id: string;
  platform: string;
  url: string;
  user_name?: string | null;
  user_email?: string | null;
  views: string;
  earnings_cents: number;
};

export type TopEarningClipsPage = { data: TopEarningClipRow[]; total: number; pageCount: number };
export type TopEarningClipsQuery = { adminCpmCampaignTopEarningClips: TopEarningClipsPage };

export function approvedTopEarningClips<T extends { earnings_cents: number }>(
  clips: T[],
): T[] {
  return clips.filter((clip) => clip.earnings_cents > 0);
}

export function isMediaDownloadPending(status?: string | null): boolean {
  return status === 'queued' || status === 'processing';
}

function csvCell(value: string): string {
  if (/[",\n]/.test(value)) return `"${value.replace(/"/g, '""')}"`;
  return value;
}

export function buildTopEarningClipsCsv(clips: TopEarningClipRow[]): string {
  const header = 'rank,platform,url,submitter,views,earnings_cents';
  const rows = approvedTopEarningClips(clips).map((clip, index) => [
    String(index + 1),
    clip.platform,
    clip.url,
    clip.user_name || clip.user_email || '',
    clip.views,
    String(clip.earnings_cents),
  ].map(csvCell).join(','));
  return [header, ...rows].join('\n');
}
